import {EventEmitter, Injectable} from '@angular/core';
import {ProdDialogService, ProdDialogData, ProdDialogType} from "prod-dialog";
import {ScannerComponent} from "../components/scanner/scanner.component";

@Injectable({
  providedIn: 'root'
})
export class BarcodeScannerService {
  scanSuccess$: EventEmitter<string> = new EventEmitter<string>();

  constructor(private dialogService: ProdDialogService) {
  }

  openScanner() {
    this.dialogService.open(new ProdDialogData({
      component: ScannerComponent,
      type: ProdDialogType.COMPONENT,
    }))
  }
}
